export default __webpack_public_path__ + "static/media/white01.46115e45.jpg";